import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { QRCodeComponent } from 'angularx-qrcode';

import { MiscModule } from '../../misc.module';
import { ShareContactInfoPageRoutingModule } from './share-contact-info-routing.module';
import { ShareContactInfoPageComponent } from './share-contact-info.page';

@NgModule({
  declarations: [ShareContactInfoPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ShareContactInfoPageRoutingModule,
    ReactiveFormsModule,
    QRCodeComponent,
    MiscModule
  ]
})
export class ShareContactInfoPageModule {}
